import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconHangupExit } from '../../../base/icons/svg';
import { isLocalParticipantModerator } from '../../../base/participants/functions';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
/**
 * Implementation of a button for toggling the hangup menu.
 */
class HangupToggleButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.hangup';
    icon = IconHangupExit;
    label = 'toolbar.endMeeting';
    toggledIcon = IconHangupExit;
    toggledLabel = 'toolbar.endMeeting';
    tooltip = 'toolbar.endMeeting';
    /**
     * 打开菜单时仍显示退出图标，避免切成关闭叉导致红色退出态丢失。
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props.isOpen;
    }
    /**
     * {@inheritDoc}
     */
    _getLabel() {
        return this.props._showEndMeeting ? 'toolbar.endMeeting' : 'toolbar.hangup';
    }
    /**
     * {@inheritDoc}
     */
    _getTooltip() {
        return this._getLabel();
    }
    /**
     * {@inheritDoc}
     */
    _getAccessibilityLabel() {
        return this.props._showEndMeeting
            ? 'toolbar.endMeeting'
            : 'toolbar.accessibilityLabel.hangup';
    }
    /**
     * Indicates whether a key was pressed.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _onKeyDown() {
        this.props.onKeyDown();
    }
}
/**
 * Maps (parts of) the redux state to the associated props.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const conference = state['features/base/conference'].conference;
    const isModerator = isLocalParticipantModerator(state);
    return {
        _showEndMeeting: Boolean(conference?.isEndConferenceSupported() && isModerator)
    };
}
export default connect(_mapStateToProps)(translate(HangupToggleButton));
